import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=bc2769d8&scoped=true&xmlns%3Afont-size=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=bc2769d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2769d8",
  null
  
)

export default component.exports